/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useEffect, useRef, useState } from "react"
import { brandColors } from "./EOSThemeProvider"

/**
 * A splash screen that fades out when is loaded prop is set. It lasts for at least 750ms.
 * It displays the logo in the center which animates in
 */
export function LoadingScreen({ isLoaded }: { isLoaded: boolean }) {
  const [canHide, setCanHide] = useState(false)

  // Slide in animation using js animate
  const ref = useRef<HTMLDivElement>(null)

  function slideIn() {
    const div = ref.current
    if (div) {
      div.animate(
        [
          {
            transform: "translateY(10px)",
            opacity: 0,
          },
          {
            transform: "translateY(0)",
            opacity: 1,
          },
        ],
        {
          duration: 300,
          iterations: 1,
          easing: "ease-out",
        },
      )
    }
  }

  // Set can hide to true after 750ms
  useEffect(() => {
    setTimeout(() => setCanHide(true), 1000)
  }, [])

  const displaySplash = !canHide || !isLoaded

  return (
    <div
      css={css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(
          ellipse at center,
          ${brandColors.night} 0%,
          ${brandColors.darkNight} 100%
        );
        opacity: ${displaySplash ? 1 : 0};
        transition: opacity 100ms;
        z-index: 100;
        pointer-events: ${displaySplash ? "all" : "none"};
        display: grid;
        place-items: center;
      `}
    >
      <div>
        <div
          ref={ref}
          css={css`
            width: 64px;
            border-radius: 4px;
            overflow: hidden;

            img {
              display: block;
              width: 100%;
              overflow: hidden;
              margin: 0 auto;
            }
          `}
        >
          <img src="https://api.fileboy.io/files/get/c173c583-ffcb-4dc0-957f-28ece09fac17+loading_gif" />
        </div>
      </div>
    </div>
  )
}
